import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PatientImmunizationsUIHelpers";

const PatientImmunizationsUIContext = createContext();

export function usePatientImmunizationsUIContext() {
  return useContext(PatientImmunizationsUIContext);
}

export const PatientImmunizationsUIConsumer =
  PatientImmunizationsUIContext.Consumer;

export function PatientImmunizationsUIProvider({
  PatientImmunizationsUIEvents,
  children,
}) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const [ids, setIds] = useState([]);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openDetailPatientAppointmentPage:
      PatientImmunizationsUIEvents.openDetailPatientAppointmentPage,
  };

  return (
    <PatientImmunizationsUIContext.Provider value={value}>
      {children}
    </PatientImmunizationsUIContext.Provider>
  );
}
